import { UseMutationOptions } from 'react-query'
import { BaseApiResponse } from '../../../api/shared'
import { HTTPError } from '../../../api/fetch/decorate-fetch'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { ThisConnector } from '../../../api/connector'

interface AgentToDeleteForm {
  orgUuid: string
  agentUid?: string
}

export async function deleteAgentUser(
  this: ThisConnector,
  { orgUuid, agentUid }: AgentToDeleteForm
) {
  return this.connector.executeDelete<BaseApiResponse>(
    `/organizations/${orgUuid}/agent-users/${agentUid}`
  )
}

export const useDeleteAgentUser = (
  options: UseMutationOptions<BaseApiResponse, HTTPError, AgentToDeleteForm>
) => {
  return useContrastMutation<BaseApiResponse, HTTPError, AgentToDeleteForm>(
    deleteAgentUser,
    { ...options }
  )
}
